import graphqlClient from '~/graphql/graphqlClient';

export type PlayerInnSubmodeStateResult = {
  didNewTourneyPlacement: boolean;
  playerInnSubmodeState: any;
  tourneyInstance: any;
};

export type QueryGetPlayerInnSubmodeStateArgs = {
  playerId: string;
  gameSubmode: string;
};

const query = `
query GetPlayerInnSubmodeState($playerId: String!, $gameSubmode: String!) {
  getPlayerInnSubmodeState(playerId: $playerId, gameSubmode: $gameSubmode) {
    didNewTourneyPlacement
    playerInnSubmodeState
    tourneyInstance
  }
}
`;

export default async function queryGetPlayerInnSubmodeState(
  args: QueryGetPlayerInnSubmodeStateArgs
): Promise<PlayerInnSubmodeStateResult> {
  return await graphqlClient.request<PlayerInnSubmodeStateResult>(
    'getPlayerInnSubmodeState',
    query,
    args
  );
}
